import axios from 'axios';

const APIURL = '/api';

export const findAddressAPI = (address: string) => {
  return axios.post(`${APIURL}/findadress`, {
    address
  });
}
